import update from 'react-addons-update';

const iState = {
    data: [],
}

const MapReducer = (state = iState, action) => {
    switch (action.type) {
        case 'UpdateData':
            return {...state, data: action.payload.map(item => ({...item, showMarker: false }))}
        default:
            return state;
    }
}

export default MapReducer;